module.exports = __webpack_public_path__ + "static/avatar-e77f81045098427c8d71b5be55ac9996.jpg";